import { Interceptor } from "@core/api/interceptors/interceptor";
import { RegistrationStatus } from "@domain/user/user";
import { UserStatusManager } from "@domain/user/user-status-manager";
import { isNotNil } from "@utils/assert";
import { AxiosResponse } from "axios";

export const getPTStatusInterceptor: (
	userStatusManager: UserStatusManager,
) => Interceptor<AxiosResponse> = userStatusManager => ({
	onFulfilled: async (response: AxiosResponse) => {
		const ptStatusHeaderValue: string | undefined = response.headers["x-pt-registration-status"];
		if (isNotNil(ptStatusHeaderValue)) {
			const ptStatus = RegistrationStatus[ptStatusHeaderValue as keyof typeof RegistrationStatus];
			if (isNotNil(ptStatus)) {
				userStatusManager.updatePtRegistrationStatus(ptStatus as RegistrationStatus);
			}
		}
		return response;
	},
});
